import { render } from "./single.vue?vue&type=template&id=27de64cd&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"

import "./single.vue?vue&type=style&index=0&id=27de64cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27de64cd"]])

export default __exports__